export default "__VITE_ASSET__mh4LrNz9__"